import {
  ADD_ATTENDENCE,
  UPDATE_ATTENDENCE,
  DELETE_ATTENDENCE,
  GET_ATTENDENCE,
} from "../type";
import { InsertData, InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";

export function buildAttendanceQuery(params = {}) {
  const searchParams = new URLSearchParams();
  const normalized = {
    From: params.from ?? params.From,
    To: params.to ?? params.To,
    SearchTerm: params.searchTerm ?? params.SearchTerm,
    PageNumber: params.pageNumber ?? params.PageNumber,
    PageSize: params.pageSize ?? params.PageSize,
  };

  Object.entries(normalized).forEach(([key, value]) => {
    const text = String(value ?? "").trim();
    if (!text || text === "null" || text === "undefined") return;
    searchParams.append(key, text);
  });

  return searchParams.toString();
}

export const CreateAttendenceAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertDataWithImage(`/api/Attendance`, data);
    dispatch({
      type: ADD_ATTENDENCE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_ATTENDENCE,
      payload: "Error" + e,
    });
  }
};

export const GetAllAttendenceAction = (query) => async (dispatch) => {
  try {
    const queryString =
      typeof query === "string"
        ? buildAttendanceQuery(Object.fromEntries(new URLSearchParams(query)))
        : buildAttendanceQuery(query);
    const url = queryString ? `/api/Attendance?${queryString}` : `/api/Attendance`;
    const respons = await GetDataToken(url);
    dispatch({
      type: GET_ATTENDENCE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_ATTENDENCE,
      payload: "Error" + e,
    });
  }
};

export const UpdateAttendenceAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/Attendance`, body);
    dispatch({
      type: UPDATE_ATTENDENCE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_ATTENDENCE,
      payload: "Error" + e,
    });
  }
};

export const DeleteAttendenceAction = (Id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/Attendance?id=${Id}`);
    dispatch({
      type: DELETE_ATTENDENCE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_ATTENDENCE,
      payload: "Error" + e,
    });
  }
};
